app.filter('money', ['$sce', '$rootScope', function ($sce, $rootScope) {

    let _currencyCode = window.membershipCurrencyCode || null;

    if (!_currencyCode) {
        try {
            Object.defineProperty(window, 'membershipCurrencyCode', {
                set: function (value) {
                    _currencyCode = value;
                    $rootScope.$applyAsync();
                },
                get: function () {
                    return _currencyCode;
                },
                configurable: true
            });
        } catch (e) {}
    }

    function moneyFilter(amount, symbol) {
        let culture = gym[0].Culture || 'en-US';
        let currency = _currencyCode || window.membershipCurrencyCode || 'USD';
        if (typeof customCurrency !== 'undefined' && customCurrency) currency = customCurrency;

        amount = parseFloat(amount);

        let formatted = '';
        if (typeof amount === 'number' && !isNaN(amount)) {
            formatted = new Intl.NumberFormat(culture, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        }

        return $sce.trustAsHtml(formatted);
    }

    moneyFilter.$stateful = true;
    return moneyFilter;
}]);